var map = {
	"./about-us.svg": 794,
	"./betting-icon.svg": 795,
	"./bonus.svg": 796,
	"./coin.svg": 797,
	"./contact-us.svg": 798,
	"./download-app.svg": 799,
	"./edit-btn.svg": 800,
	"./feedback.svg": 801,
	"./global.svg": 802,
	"./info-centre.svg": 803,
	"./info-centre.webp": 1592,
	"./mall-icon.svg": 804,
	"./message.svg": 805,
	"./personal-info-edit.svg": 806,
	"./r77-coin.svg": 807,
	"./r77-rewards.svg": 808,
	"./redemption-icon.svg": 809,
	"./referral.svg": 810,
	"./resp-gaming.svg": 811,
	"./security.svg": 812,
	"./transaction-icon.svg": 813,
	"./vip-icon.svg": 814,
	"./wallet-icon.svg": 815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;